"use strict";

jQuery(($) => {
	// // Contact page
	const $filter = $(".filter-box > select");
	const $forms = $("form.contact");
	const $loading = $('<div />', {
		id: "loading"
	});

	if ($filter.length && $forms.length) {
		const firstForm = $forms[0];

		// Set first form to active
		$(firstForm).attr('data-active', 'true');

		// Switch form on change
		$filter.on("change", function(e) {
			const tabKey = $(this).val();

			const currentlyActive = $(`form[data-active="true"]`);
			if (currentlyActive.length) {
				currentlyActive.attr("data-active", "false");
			}

			const nextTab = $(`form[data-form="${tabKey}"]`);
			if (nextTab.length) {
				nextTab.attr("data-active", "true");
			}
		});
	}

});